var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',_vm._l((_vm.headers),function(header){return _c('td',{key:header.text},[(header.value === _vm.options?.totalCalculate?.titleField)?_c('b',[_vm._v("Total")]):_vm._e(),_vm._v("\n    "+_vm._s(_vm.fmt(_vm.rowData[header.value]))+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }